import React, { useEffect, useState } from 'react';
import {
    Button, Grid, Paper, Stack, Box,
    TableBody, TableCell, styled, tableCellClasses, IconButton, TableRow, Switch
} from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { format } from "date-fns";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import Controls from '../controls/Controls';
import UseTable from '../common/UseTable';
import { getClientsApps, loadClientApp } from '../../store/clients';
import Notification from '../common/Notification';
import AddApp from './AddApp';
import Popup from '../common/Popup';
import { useLocation } from 'react-router-dom';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
        whiteSpace: "nowrap",
    },
}));

const headCells = [
    { id: "id", label: "S. No." },
    { id: "dateTime", label: "Date & Time" },
    {
        id: "name",
        label: "Name",
        editable: true,
    },
    {
        id: "",
        label: "Action",
        sortable: false,
    },
    {
        id: "",
        label: "Status",
        sortable: false,
    }

];

const ClientApp = () => {
    // Placeholder state for managing applications
    const [applications, setApplications] = useState([]);
    const [addAppPopup, setAddAppPopup] = useState(false);
    const [selectedApp, setSelectedApp] = useState(null);
    const [selectedClient, setSelectedClient] = useState(null);

    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });

    const [filterFn, setFilterFn] = useState({
        fn: (items) => {
            return items;
        },
    });

    const dispatch = useDispatch();

    const location = useLocation();

    useEffect(() => {
        if (location.state?.id > 0) {
            setSelectedClient(location.state);
            dispatch(loadClientApp(location.state.id));
        }
    }, []);

    const clientAppSelector = useSelector(getClientsApps);

    // Example handler for adding a new application
    const handleAddApplication = () => {
        const newApp = { id: Date.now(), name: 'New Application' };
        setApplications([...applications, newApp]);
    };

    // Example handler for removing an application
    const handleRemoveApplication = (id) => {
        setApplications(applications.filter(app => app.id !== id));
    };

    const handleTogglePopup = () => {
        setAddAppPopup(!addAppPopup);
    }

    const handleAddApp = (item) => {
        if (item === "save") {
            if (selectedClient?.id > 0)
                dispatch(loadClientApp(selectedClient.id));
        }
        else setSelectedApp(item);
        setAddAppPopup(!addAppPopup);
    }

    const handleClosePopup = () => {
        setAddAppPopup(false);
        setSelectedApp(null);
    }

    const {
        TblContainer,
        TblHeader,
        TblPagination,
        tblDataAfterPaginationAndSorting,
    } = UseTable(clientAppSelector, headCells, filterFn);

    return (
        <>
            <Box display="flex" alignItems="center" justifyContent="left" mb={-3}>
                <b>Client : {selectedClient?.clientId} - {selectedClient?.name}</b>
            </Box>
            <Box display="flex" alignItems="right" justifyContent="right" mb={2}>

                <Controls.Button
                    onClick={handleTogglePopup}
                    text="Add New"
                    variant="outlined"
                    size="small"
                    startIcon={<AddIcon />}
                    sx={{

                        color: 'black',
                        border: "1px solid black",
                        '&:hover': {
                            backgroundColor: 'black',
                            color: 'white',

                        }
                    }}
                >
                </Controls.Button>
            </Box>
            <Paper sx={{ overflow: "auto" }}>
                <TblContainer>
                    <TblHeader />
                    <TableBody>
                        {tblDataAfterPaginationAndSorting().map((item) => (
                            <TableRow key={item.id}>
                                <TableCell>{item.id}</TableCell>
                                <StyledTableCell>
                                    {format(new Date(item.addedDateTime), "MM/dd/yyyy, h:mma")}
                                </StyledTableCell>
                                <StyledTableCell>{item.clientId}</StyledTableCell>
                                <StyledTableCell>{item.name}</StyledTableCell>
                                <StyledTableCell>{item.contactName}</StyledTableCell>
                                <TableCell>
                                    <IconButton
                                        color="primary"
                                        component="span"
                                        size="small"
                                        title="Edit Client"
                                        onClick={() => handleAddApp(item)}
                                    >
                                        <EditIcon fontSize="small" />
                                    </IconButton>
                                </TableCell>
                                <TableCell>
                                    <Switch
                                        checked={item.status}
                                        //onChange={() => handleSwitchChange(item)}
                                        sx={{
                                            '& .MuiSwitch-switchBase.Mui-checked': {
                                                color: '#12d412',
                                            },
                                            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                                backgroundColor: '#12d412',
                                            },
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </TblContainer>
                <TblPagination />
            </Paper>
            <Popup
                title={selectedApp ? "Edit Application" : "Add Application"}
                openPopup={addAppPopup}
                setOpenPopup={setAddAppPopup}
                handleOpenPopup={handleAddApp}
                size="lg"
            >
                <AddApp
                    setNotify={setNotify}
                    setOpenPopup={setAddAppPopup}
                    selectedApp={selectedApp}
                    handleAddApp={handleAddApp}
                />
            </Popup>
            <Notification notify={notify} setNotify={setNotify} />
        </>
    );
};

export default ClientApp;